



















































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { saveFile, converBase64toBlob, getPersianDate } from '@/util/utils';
import LetterAttachment from '@/components/Cartable/LetterDetails/LetterAttachment/LetterAttachment.vue';
import * as fileService from '@/store/Services/fileService';
import * as letterService from '@/store/Services/letterServices';
import Parts from '@/store/models/Letter/Parts';
import LetterTrailTree from './LetterTrail/LetterTrailTree.vue';
import { LetterTrail } from '@/store/models/Letter/LetterTrail';
import * as $ from 'jquery';
import FinalizeLetter from './FinalizeLetter/FinalizeLetter.vue';
import * as util from '@/util/utils.ts';
import { LetterSearchResult } from '../../../store/models/Letter/LetterSearchResult';
@Component({
    name:"SearchResultDetails",
    components:{LetterAttachment, LetterTrailTree, FinalizeLetter}
})
export default class SearchResultDetails extends Vue {

    isReceived = true;
    pdfSrc = {} as any;
    @Prop() searchResult?: LetterSearchResult;
    @Watch("letter")
    onLetterChanged(newVal: LetterSearchResult, oldVal: LetterSearchResult){
        this.setIsReceived();
        this.setPdfUrl();
    }
    
       
    created(){
        this.setIsReceived();
    }
    get attachments(){
        
        const result: Parts[] = [];
        if(this.searchResult === undefined)return result;
        if(this.searchResult.parts === undefined || this.searchResult.parts === null)return result;
        for(let i = 1;i<this.searchResult.parts.length;i++){
            result.push(this.searchResult.parts[i]);
        }
        return result;
    }

    get letterTime(){
        
        if(!this.searchResult) return '';
        const date = new Date( this.searchResult.sendTime.substring(0,this.searchResult.sendTime.length -1));
        return (date).toLocaleTimeString();
    }

   
    
    setIsReceived(){
        this.isReceived = false;
        if(this.searchResult == undefined)return;
        if(this.searchResult.to === null)
            this.isReceived = true;
    }

    async downloadLetterPdf(){
        if(this.searchResult === undefined)return;
        if(this.searchResult.parts === undefined || this.searchResult.parts === null)return;
        const file = await fileService.getFile(this.searchResult.parts[0].file.id);
        const blob =  converBase64toBlob(file.content||"",'');
        saveFile(blob,file.extension);
    }
    pdfLoaded = false;
    async setPdfUrl(){
         if(this.searchResult === undefined)return;
        if(this.searchResult.parts === undefined || this.searchResult.parts === null)return;
            this.pdfLoaded = false;
            const file = await fileService.getFile(this.searchResult.parts[0].file.id);
            // const blob =  converBase64toBlob(file.content,file.extension);
            // this.pdfSrc = blob;
            // console.log(blob);
            this.pdfSrc = "data:application/pdf;base64," + file.content;
            this.pdfLoaded = true;

        
    }
    async mounted(){
        $("#options-dropdown").dropdown({action: 'hide',silent: true});
        await this.setPdfUrl();
    }

    finalizeLetter(){
        if(this.searchResult === undefined || this.searchResult === null) return;
        this.$emit('finalize-letter',this.searchResult.letterId);
    }
    forwardLetter(){
        if(this.searchResult)
            this.$emit('forward-letter',this.searchResult.letterId);
    }

}
